<script setup lang="ts">
import { useUserStore } from '@/stores/user';
import { useRouter } from 'vue-router';

const router = useRouter();
const userStore = useUserStore();


const logout = async () => {
  // Await logout to ensure cleanup completes before redirect
  await userStore.logout();
  // Use router.push for SPA navigation to maintain smooth user experience
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  router.push('/login');
};
</script>

<template>
  <div class="flex flex-col items-center justify-center h-screen bg-white">
    <h1 class="text-[4rem] font-bold animate-bounce duration-1000">404</h1>
    <p class="text-gray-500 text-lg">Looks like you got on the wrong track</p>
    <router-link
      to="/"
      class="bg-blue-500 text-white px-4 py-2 rounded-md mt-2 hover:bg-blue-600 transition-all duration-200 hover:translate-y-[-1px] hover:shadow-md"
      >Return to website</router-link
    >
    <button @click="logout">Logout</button>
  </div>
</template>
